/* eslint-disable no-console */
/* eslint-disable max-depth */
/* eslint-disable max-statements */
/* eslint-disable complexity */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { noop, isEmpty, isObject } from '@mindtickle/utils';
import { EMPTY_OBJECT_READONLY } from '../config/constants';
import QueueWithTimer from './QueueWithTimer';
import { logToMindTickle, timestamp } from '.';
var PRIMARY_INSTANCE_NAME = 'kamlesh';
var MIXPANEL_BEACON_API = '/logBrowserInteractionTime';
var mixpanelManager = /** @class */ (function () {
    function mixpanelManager() {
        var _this = this;
        this.mixpanel = null;
        this.init = function (mixpanelId, userMeta) { return __awaiter(_this, void 0, void 0, function () {
            var userId, mixpanelModule, setupMixpanelGlobals, error_1, mixpanelIds, projectIdsCount, mixpanelProjectId, config_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        userId = userMeta.userId;
                        this._userId = userId;
                        if (!process.env.TRACKING)
                            return [2 /*return*/];
                        if (!process.env.MIXPANEL_PROJECT_ID) return [3 /*break*/, 5];
                        if (this.hasInit) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        console.log('Lazy loading Mixpanel Lib....');
                        return [4 /*yield*/, import(
                            /* webpackChunkName: "mixpanel-js" */ '../library/mixpanel')];
                    case 2:
                        mixpanelModule = _a.sent();
                        if (mixpanelModule && mixpanelModule.default) {
                            setupMixpanelGlobals = mixpanelModule.default;
                            this.mixpanel = setupMixpanelGlobals(PRIMARY_INSTANCE_NAME);
                        }
                        else {
                            console.error('Error: Mixpanel module or its default export not available.');
                            return [2 /*return*/];
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.error('Error loading Mixpanel Library:', error_1);
                        return [2 /*return*/];
                    case 4:
                        this._hasInit = true; //inits mixpanel
                        mixpanelIds = process.env.MIXPANEL_PROJECT_ID.split('#');
                        projectIdsCount = mixpanelIds.length;
                        mixpanelProjectId = process.env.MIXPANEL_PROJECT_ID;
                        config_1 = {
                            debug: process.env.MIXPANEL_DEBUG || false,
                            persistence: 'localStorage',
                            api_host: 'https://mt-fe-dc.mindtickle.com',
                        };
                        if (projectIdsCount > 1) {
                            mixpanelProjectId = mixpanelIds[0].split(':')[0];
                        }
                        this.mixpanel = this.mixpanel.init(mixpanelProjectId, config_1);
                        this.mixpanel.people.set({ id: userId });
                        this.mixpanel.identify(mixpanelId);
                        if (projectIdsCount > 1) {
                            mixpanelIds.shift();
                            mixpanelIds.forEach(function (mixpanelIds) {
                                var _a = __read(mixpanelIds.split(':'), 2), id = _a[0], projectName = _a[1];
                                _this.mixpanel.init(id, config_1, projectName);
                                _this.mixpanel[projectName].people.set({ id: userId });
                                _this.mixpanel[projectName].identify(mixpanelId);
                            });
                        }
                        if (process.env.MIXPANEL_BATCHING) {
                            this.queue.start();
                        }
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        this.addToQueue = function (event, data) {
            data.time = timestamp() / 1000;
            _this.queue.add({
                event: event,
                properties: data,
            });
        };
        this._sendTrackEventUsingBeacon = function (event, eventData) {
            var distinct_id = _this._userId;
            var dataToSend = JSON.stringify({
                distinct_id: distinct_id,
                event: event,
                properties: __assign({}, eventData),
            });
            if ('sendBeacon' in navigator) {
                navigator.sendBeacon(MIXPANEL_BEACON_API, dataToSend);
            }
        };
        this.track = function (event, data, sendUsingBeacon) {
            if (sendUsingBeacon === void 0) { sendUsingBeacon = false; }
            if (!_this.hasInit) {
                return;
            }
            var eventData = _this.getDerivedEventData(data);
            // This used for sending event when page is being unloaded as normal XHR request doesn't work for this case.
            if (sendUsingBeacon && process.env.MIXPANEL_PROJECT_ID) {
                _this._sendTrackEventUsingBeacon(event, eventData);
                return;
            }
            if (process.env.MIXPANEL_BATCHING && process.env.MIXPANEL_PROJECT_ID) {
                _this.addToQueue(event, eventData);
                logToMindTickle(event, eventData);
                return;
            }
            window.setTimeout(function () {
                if (process.env.MIXPANEL_PROJECT_ID) {
                    _this.mixpanel.track(event, eventData);
                    _this.mixpanelProjects.forEach(function (projectName) {
                        return _this.mixpanel[projectName].track(event, eventData);
                    });
                }
                logToMindTickle(event, eventData);
            }, 400);
        };
        this._params = {
            contextData: {},
            errorTracking: true,
        };
        this._hasInit = false;
        this._contextGetter = noop;
        var allMixpanelIds = process.env.MIXPANEL_PROJECT_ID.split('#');
        this.mixpanelProjects = [];
        if (allMixpanelIds.length > 1) {
            allMixpanelIds.shift();
            this.mixpanelProjects = allMixpanelIds.map(function (project) {
                var _a = __read(project.split(':'), 2), projectName = _a[1];
                return projectName;
            });
        }
        if (process.env.MIXPANEL_BATCHING) {
            this.queue = QueueWithTimer({
                batchSize: process.env.MIXPANEL_BATCH_SIZE,
                fireTime: process.env.MIXPANEL_THROTTLE_TIME,
                callback: function (events) {
                    _this.mixpanel.trackBatch(events);
                    _this.mixpanelProjects.forEach(function (projectName) {
                        return _this.mixpanel[projectName].trackBatch(events);
                    });
                },
            });
        }
    }
    mixpanelManager.prototype.setParams = function (newParams) {
        var receivedParams = isObject(newParams) ? newParams : EMPTY_OBJECT_READONLY;
        this._params = __assign(__assign({}, this._params), receivedParams);
    };
    mixpanelManager.prototype.setContextGetter = function (contextGetterFn) {
        if (typeof contextGetterFn !== 'function') {
            return;
        }
        this._contextGetter = contextGetterFn;
    };
    Object.defineProperty(mixpanelManager.prototype, "params", {
        get: function () {
            return this._params;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(mixpanelManager.prototype, "errorTracking", {
        get: function () {
            return this._errorTracking;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(mixpanelManager.prototype, "hasInit", {
        get: function () {
            return this._hasInit;
        },
        enumerable: false,
        configurable: true
    });
    mixpanelManager.prototype.getDerivedEventData = function (data) {
        var _a, _b;
        var eventData;
        if (isEmpty(data.contextData)) {
            eventData = __assign(__assign(__assign({}, this.params), data), this.params.contextData); // use default context
        }
        else {
            eventData = __assign(__assign(__assign({}, this.params), data), data.contextData); // use context if recieved from withTracking
        }
        var customContext = this._contextGetter();
        customContext = customContext ? customContext : EMPTY_OBJECT_READONLY;
        eventData = __assign(__assign({}, eventData), customContext);
        ['contextData', 'contextId', 'errorTracking'].forEach(function (key) {
            delete eventData[key];
        });
        eventData['Zipy Url'] = ((_b = (_a = window.zipy) === null || _a === void 0 ? void 0 : _a.getCurrentSessionURL) === null || _b === void 0 ? void 0 : _b.call(_a)) || 'zipy url not available';
        return eventData;
    };
    return mixpanelManager;
}());
export { mixpanelManager };
var mixpanelSingleton = new mixpanelManager();
export default mixpanelSingleton;
//# sourceMappingURL=mixpanelManager.js.map